import { DecimalPipe } from '@angular/common';
import { Component, inject, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { toStringArray } from '@forgerock/backstage-ui-core';
import { BehaviorSubject } from 'rxjs';
import { AppSearchParamsInt } from '../../model/app-search-params';
import { HtmlDecodePipe } from '../../pipe/html-decode.pipe';
import { KeyValueCount } from '../../utils/key-value-count';
import { SearchParamsContainerComponent } from '../search-params-container/search-params-container.component';

@Component({
  selector: 'app-search-filter-value-list',
  templateUrl: './search-filter-value-list.component.html',
  styleUrls: [ './search-filter-value-list.component.scss' ],
  imports: [ DecimalPipe, HtmlDecodePipe ]
})
export class SearchFilterValueListComponent implements OnInit, OnChanges {
  container = inject(SearchParamsContainerComponent);

  @Input() keyValues: KeyValueCount[] = [];
  @Input() filterName: keyof AppSearchParamsInt;
  @Input() minResults = 0;
  @Output() visible = new BehaviorSubject<boolean>(false);
  selectedValues = new Set<string>();

  async ngOnInit(): Promise<void> {
    this.container.paramsChange.subscribe({
      next: params => {
        const values = params[ this.filterName ] as any;
        this.selectedValues = new Set(toStringArray(values));
      }
    });
  }

  ngOnChanges({ keyValues }: SimpleChanges) {
    setTimeout(() => this.visible.next((keyValues.currentValue as KeyValueCount[])?.length > this.minResults));
  }

  toggleValue(filterValue: string) {
    if (this.selectedValues.has(filterValue)) {
      this.selectedValues.delete(filterValue);
    } else {
      this.selectedValues.add(filterValue);
    }
    this.container.setParams({ [ this.filterName ]: Array.from(this.selectedValues) });
  }

  protected readonly decodeURIComponent = decodeURIComponent;
}
